import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { apiEndpoints } from "../../core/constants/api-strings";
import { BaseHttpService, HttpResult } from "../../core/services/base-http.service";
import { BaseResponse } from "../../shared/models/base-response.model";

@Injectable({
    providedIn: "root",
})
export class VirtualEventApiService extends BaseHttpService {
    constructor() {
        super();
    }

    // Base URL for farmer-related APIs
    private readonly farmerBaseUrl = environment.farmer_base_url;

    // Logged-in farmer's ID
    private farmerId = this.storage.getLoggedUserId();

    // Event code, defaults to 'KISAN25' if not set
    private eventcode = this.storage.getEventCode() || "KISAN25";

    registerVirtualVisitor(): Observable<HttpResult<BaseResponse<any>>> {
        let serviceName = `${this.farmerBaseUrl +
            this.farmerId +
            apiEndpoints.farmerRegister.events +
            this.eventcode +
            apiEndpoints.farmerRegister.virtual_visitor_register
            }`;

        // Make a GET request to the constructed service URL with authentication
        return this.post<BaseResponse<any>>(
            serviceName,
            {},
            {},
            true
        );
    }
}
